import { Button, Col, Form, Input, Modal, Row, useModalForm } from "@pankod/refine-antd";
import { InputValidatorRegex, IUser } from "../../../../interfaces/company";
import { urlPath } from "utility/url";
import { useState } from "react";


export const LinkIndusIndCardComponent: React.FC<{
    refetchUsers: any,
    userItem: IUser,
}> = ({ userItem, refetchUsers }) => {

    let url = urlPath();
    const [firstSixDigits, setFirstSixDigits] = useState(null);
    const [lastFourDigits, setLastFourDigits] = useState(null);

    const onFormValueChange = (changedValues: any, allValues: any) => {
        if (changedValues.firstSixDigits) {
            setFirstSixDigits(changedValues.firstSixDigits);
        }
        if (changedValues.lastFourDigits) {
            setLastFourDigits(changedValues.lastFourDigits);
        }
    };

    const { modalProps, formProps, show: showLinkIndusIndCardModal, close: closeModal } = useModalForm<any>({
        resource: 'mapIndusIndCardToUserFromInternalPortal',
        dataProviderName: "grapghQl",
        action: "create",
        metaData: {
            input: {
                companyId: url.lastElement,
                userAccountId: userItem.userAccounts[0].id,
                firstSixDigits,
                lastFourDigits,
            }
        },
        redirect: false,
        onMutationSuccess(data, variables, context) {
            refetchUsers(true);
            formProps.form?.resetFields();
        }
    });
    modalProps.title = `Link IndusInd Bank Card`;
    modalProps.centered = true;
    modalProps.width = 600;
    modalProps.onCancel = () => {
        formProps.form?.resetFields();
        closeModal();
    }

    return (
        <>
            {
                <Button onClick={() => { showLinkIndusIndCardModal(); }} type="default">
                    Link Card
                </Button>
            }
            <Modal {...modalProps}>
                <Form {...formProps} onValuesChange={onFormValueChange} name="mappingDetails" layout="vertical">
                    <Row gutter={16}>
                        <Col lg={12}>
                            <Form.Item className="w-100" rules={[
                                {
                                    message: 'Enter correct value',
                                    pattern: InputValidatorRegex.SIX_DIGITS,
                                },
                            ]} label="First 6 Digits of your card" name="firstSixDigits">
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item label="Last 4 Digits of Card" rules={[
                                {
                                    message: 'Enter correct value',
                                    pattern: InputValidatorRegex.FOUR_DIGITS,
                                },
                            ]} className="w-100" name="lastFourDigits">
                                <Input />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </Modal>
        </>
    );
}